var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_11",
    "data-name": "Raggruppa 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.947,
    height: 10,
    viewBox: "0 0 9.947 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M76.272,9.222c0-.4.237-.608.473-.608s.473.207.473.608v.212a.882.882,0,0,1,.357.441h2.387a.3.3,0,0,1,.278.185h0l1.325,3.81a.065.065,0,0,1,0,.059.061.061,0,0,1-.052.028h-.52a.058.058,0,0,1-.057-.037l-.966-2.984-.957,2.984a.058.058,0,0,1-.057.037h-.52a.061.061,0,0,1-.052-.028.066.066,0,0,1-.005-.059l1.134-3.391H77.575a.881.881,0,0,1-.357.442v6.267a.533.533,0,0,0,.1.314c.369.538.956.427,1.639.526.468.068.448.585.078.585H74.458c-.369,0-.39-.517.078-.585.683-.1,1.27.012,1.639-.526a.533.533,0,0,0,.1-.314V10.922a.881.881,0,0,1-.357-.442H73.983l1.137,3.391a.065.065,0,0,1-.005.059.061.061,0,0,1-.052.028h-.52a.058.058,0,0,1-.057-.037l-.961-2.984-.957,2.984a.058.058,0,0,1-.057.037h-.52a.061.061,0,0,1-.052-.028.065.065,0,0,1-.005-.059l1.315-3.81h0a.3.3,0,0,1,.278-.185h2.387a.882.882,0,0,1,.357-.441V9.222ZM75.3,14.7a1.8,1.8,0,0,1-3.513,0,.312.312,0,0,1,.306-.378h2.9a.312.312,0,0,1,.306.378Zm6.4,0a1.8,1.8,0,0,1-3.513,0,.312.312,0,0,1,.306-.378h2.9a.312.312,0,0,1,.305.378ZM76.745,9.829h0a.35.35,0,0,0,0,.7h.01a.35.35,0,0,0,0-.7Z",
    transform: "translate(-71.764 -8.614)",
    fill: "#2b9cfb",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "t",
    transform: "translate(0 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M70,560.1h0Z",
    transform: "translate(-70 -560.098)",
    fill: "#2b9cfb"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.001 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7",
    "data-name": "Tracciato 7",
    d: "M70.031,560.1h0Z",
    transform: "translate(-70.031 -560.098)",
    fill: "#2b9cfb"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(0.001 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M70.056,560.1h0Z",
    transform: "translate(-70.055 -560.098)",
    fill: "#2b9cfb"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "f",
    transform: "translate(0.002 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M70.082,560.1h0Zm0,0h0Z",
    transform: "translate(-70.082 -560.098)",
    fill: "#2b9cfb"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.002 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10",
    "data-name": "Tracciato 10",
    d: "M70.109,560.1h0Z",
    transform: "translate(-70.109 -560.098)",
    fill: "#2b9cfb"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "k",
    transform: "translate(0.003 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    "data-name": "Tracciato 11",
    d: "M70.16,560.1h0Zm0,0h0Z",
    transform: "translate(-70.16 -560.098)",
    fill: "#2b9cfb"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "j",
    transform: "translate(0.004 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_12",
    "data-name": "Tracciato 12",
    d: "M70.207,560.1h0Zm0,0h0Z",
    transform: "translate(-70.207 -560.098)",
    fill: "#2b9cfb"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "i",
    transform: "translate(0.005 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_13",
    "data-name": "Tracciato 13",
    d: "M70.238,560.1h0Z",
    transform: "translate(-70.238 -560.098)",
    fill: "#2b9cfb"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "e",
    transform: "translate(0.006 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_14",
    "data-name": "Tracciato 14",
    d: "M70.282,560.1h0Zm0,0h0Z",
    transform: "translate(-70.281 -560.098)",
    fill: "#2b9cfb"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(0.007 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15",
    "data-name": "Tracciato 15",
    d: "M70.313,560.1h0Zm0,0h0Z",
    transform: "translate(-70.313 -560.098)",
    fill: "#2b9cfb"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "h",
    transform: "translate(0.008 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16",
    "data-name": "Tracciato 16",
    d: "M70.371,560.1h0Z",
    transform: "translate(-70.371 -560.098)",
    fill: "#2b9cfb"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g",
    transform: "translate(0.01 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_17",
    "data-name": "Tracciato 17",
    d: "M70.45,560.1h0Z",
    transform: "translate(-70.449 -560.098)",
    fill: "#2b9cfb"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "s",
    transform: "translate(0.012 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_18",
    "data-name": "Tracciato 18",
    d: "M70.551,560.1h0Z",
    transform: "translate(-70.551 -560.098)",
    fill: "#2b9cfb"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "r",
    transform: "translate(0 9.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19",
    "data-name": "Tracciato 19",
    d: "M70,560.141h0Z",
    transform: "translate(-70 -560.141)",
    fill: "#2b9cfb"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "q",
    transform: "translate(0.001 9.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_20",
    "data-name": "Tracciato 20",
    d: "M70.071,560.141h0Z",
    transform: "translate(-70.07 -560.141)",
    fill: "#2b9cfb"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p",
    transform: "translate(0.003 9.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_21",
    "data-name": "Tracciato 21",
    d: "M70.149,560.141h0Z",
    transform: "translate(-70.148 -560.141)",
    fill: "#2b9cfb"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "o",
    transform: "translate(0.005 9.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_22",
    "data-name": "Tracciato 22",
    d: "M70.227,560.141h0Z",
    transform: "translate(-70.227 -560.141)",
    fill: "#2b9cfb"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "n",
    transform: "translate(0.006 9.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23",
    "data-name": "Tracciato 23",
    d: "M70.289,560.141h0Z",
    transform: "translate(-70.289 -560.141)",
    fill: "#2b9cfb"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "m",
    transform: "translate(0.008 9.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_24",
    "data-name": "Tracciato 24",
    d: "M70.367,560.142h0Zm0,0h0Z",
    transform: "translate(-70.367 -560.141)",
    fill: "#2b9cfb"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "l",
    transform: "translate(0.01 9.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_25",
    "data-name": "Tracciato 25",
    d: "M70.449,560.142h0Zm0,0h0Z",
    transform: "translate(-70.449 -560.141)",
    fill: "#2b9cfb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegals);
export default __webpack_public_path__ + "static/media/legals.ee67e8a2625ba7c0d57d618242b6c6f2.svg";
export { ForwardRef as ReactComponent };